<template>
    <div class="mainNavigation">
        <el-steps :active="index" align-center>
            <el-step
                v-for="(item, index) in getTextArray('motor_nav')"
                :key="item.id"
                :title="getNav(index)"
                :class="{redirectAvailable: uidSetted}"
            ></el-step>
        </el-steps>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    props: {
        index: {
            type: Number,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
    },
    computed: {
        ...mapGetters([
            'getText',
            'getTextArray',
        ]),
        uidSetted() {
            return this.$route.params.hasOwnProperty('uid');
        }
    },
    mounted() {
        let steps = document.querySelectorAll('.redirectAvailable .el-step__icon');
        steps.forEach(step => {
            step.addEventListener('click', () => {
                this.$emit('redirect', parseInt(step.textContent) - 1);
            });
        });
    },
    methods: {
        getNav(index) {
            return this.getText('motor_nav', index);
        },
    }
};

</script>

<style lang="less">

.highlight {
    background-color: #c4d600;
}

.mainNavigation {
    margin-top: 20px !important;
    margin-bottom: 20px;
}
.redirectAvailable {
    .el-step__icon {
        cursor: pointer;
    }
}
.el-step__title {
    padding-top: 20px;
}

</style>


// WEBPACK FOOTER //
// src/components/partials/wizzard/StepBar.vue